import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginRecolteur } from '../services/api';
import Footer from '../components/Footer';
import InstallPrompt from '../components/InstallPrompt';
import './LoginRecolteur.css';

const LoginRecolteur = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await loginRecolteur(identifier, password);
      
      // Stocker dans les clés spécifiques au récolteur
      localStorage.setItem('recolteur_token', response.data.token);
      localStorage.setItem('recolteur_user', JSON.stringify(response.data.admin));
      
      // Rediriger selon le rôle
      if (response.data.admin.role === 'admin') {
        // Si c'est un admin qui se connecte via cette page, utiliser les clés admin
        localStorage.setItem('admin_token', response.data.token);
        localStorage.setItem('admin_user', JSON.stringify(response.data.admin));
        navigate('/admin');
      } else {
        navigate('/recolteur');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <div className="login-box">
          <div className="logo-container">
            <img src="/logo.png" alt="MUTU NDE ESPOIR ASBL" className="logo" />
          </div>
          <h2>MUTU NDE ESPOIR ASBL</h2>
          <h3>Connexion Récolteur/Admin</h3>
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            
            <div className="form-group">
              <label>Nom d'utilisateur ou Matricule</label>
              <input
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                autoFocus
                placeholder="Nom d'utilisateur ou Matricule (ex: RCL-001)"
              />
              <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                Vous pouvez vous connecter avec votre nom d'utilisateur ou votre numéro matricule
              </small>
            </div>

            <div className="form-group">
              <label>Mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
      <InstallPrompt />
      <Footer />
    </div>
  );
};

export default LoginRecolteur;

